(function () {
  var root = document.querySelector('[data-rspp]'); if (!root || root.__rspp) return; root.__rspp = true;
  var data = {}; try { data = JSON.parse(root.querySelector('[data-rspp-json]').textContent); } catch (e) {}
  var variants = data.variants || [];
  function money(c) { return '£' + (c / 100).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (m) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[m]; }); }

  /* sticky offset under the header */
  function setTop() { var h = document.getElementById('header-group'); var t = h ? Math.round(h.getBoundingClientRect().height) : 0; root.style.setProperty('--rspp-top', t + 'px'); }
  setTop(); window.addEventListener('resize', setTop); setTimeout(setTop, 400);

  /* gallery */
  var track = root.querySelector('[data-track]'), slides = track ? track.querySelectorAll('.rspp-gal__slide') : [], countEl = root.querySelector('[data-count]'), thumbs = root.querySelectorAll('[data-thumb]');
  function curIdx() { return track ? Math.round(track.scrollLeft / Math.max(1, track.clientWidth)) : 0; }
  function go(i) { if (!track || !slides.length) return; i = (i + slides.length) % slides.length; track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); }
  if (track) {
    var st; track.addEventListener('scroll', function () { clearTimeout(st); st = setTimeout(function () { var i = curIdx(); if (countEl) countEl.textContent = i + 1; thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); }); }, 60); }, { passive: true });
    var p = root.querySelector('[data-prev]'), n = root.querySelector('[data-next]');
    if (p) p.addEventListener('click', function () { go(curIdx() - 1); });
    if (n) n.addEventListener('click', function () { go(curIdx() + 1); });
    track.addEventListener('keydown', function (e) { if (e.key === 'ArrowLeft') go(curIdx() - 1); if (e.key === 'ArrowRight') go(curIdx() + 1); });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.getAttribute('data-thumb')); }); });
  }

  /* variants */
  var form = root.querySelector('.rspp-form'), vid = root.querySelector('[data-vid]'), priceEl = root.querySelector('[data-price]'), cmpEl = root.querySelector('[data-compare]'), addBtn = root.querySelector('[data-add]');
  var fields = Array.prototype.slice.call(root.querySelectorAll('[data-opt]'));
  var current = variants.filter(function (v) { return vid && String(v.id) === vid.value; })[0] || variants[0];
  var state = current ? current.options.slice() : [];
  function find(st) { return variants.filter(function (v) { return v.options.every(function (o, i) { return o === st[i]; }); })[0]; }
  function markAvailability() {
    fields.forEach(function (f) {
      var i = +f.getAttribute('data-opt');
      f.querySelectorAll('[data-val]').forEach(function (b) {
        var val = b.getAttribute('data-val'), test = state.slice(); test[i] = val; var v = find(test);
        var na = !v || !v.available; b.classList.toggle('is-na', na);
        if (b.tagName === 'OPTION') b.textContent = val + (na ? (v ? ' — sold out' : ' — not available with this choice') : '');
      });
    });
  }
  function applyVariant(v) {
    if (!v) return; current = v; state = v.options.slice();
    if (vid) vid.value = v.id;
    fields.forEach(function (f) { var i = +f.getAttribute('data-opt'), sel = f.querySelector('[data-optsel]'); if (sel) sel.value = state[i]; f.querySelectorAll('button[data-val]').forEach(function (b) { var on = b.getAttribute('data-val') === state[i]; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); }); });
    root.querySelectorAll('[data-spec-opt]').forEach(function (td) { td.textContent = state[+td.getAttribute('data-spec-opt')] || ''; });
    if (priceEl) priceEl.textContent = money(v.price);
    if (cmpEl) { if (v.compare > v.price) { cmpEl.textContent = money(v.compare); cmpEl.hidden = false; } else cmpEl.hidden = true; }
    if (addBtn) { addBtn.disabled = !v.available; addBtn.textContent = v.available ? 'Add to basket' : 'Sold out'; }
    if (v.media && track) { slides.forEach(function (s, k) { if (String(s.getAttribute('data-media-id')) === String(v.media)) go(k); }); }
    try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); } catch (e) {}
    markAvailability(); runCheck(true);
  }
  function choose(i, val) {
    var st2 = state.slice(); st2[i] = val;
    var v = find(st2);
    if (!v) { var c = variants.filter(function (x) { return x.options[i] === st2[i]; }); v = c.filter(function (x) { return x.available; })[0] || c[0]; }
    applyVariant(v);
  }
  fields.forEach(function (f) {
    var i = +f.getAttribute('data-opt'), sel = f.querySelector('[data-optsel]');
    if (sel) sel.addEventListener('change', function () { choose(i, sel.value); });
    f.querySelectorAll('button[data-val]').forEach(function (b) {
      b.addEventListener('click', function () {
        var st2 = state.slice(); st2[i] = b.getAttribute('data-val');
        var v = find(st2);
        if (!v) { var c = variants.filter(function (x) { return x.options[i] === st2[i]; }); v = c.filter(function (x) { return x.available; })[0] || c[0]; }
        applyVariant(v);
      });
    });
  });
  markAvailability();

  /* quantity */
  var qty = root.querySelector('[data-qty]');
  root.querySelectorAll('[data-q]').forEach(function (b) { b.addEventListener('click', function () { var n = Math.max(1, (parseInt(qty.value, 10) || 1) + (+b.getAttribute('data-q'))); qty.value = n; }); });

  /* add to basket (AJAX) */
  var msg = root.querySelector('[data-msg]'), toast = root.querySelector('[data-toast]'), tt;
  if (form) form.addEventListener('submit', function (e) {
    if (e.submitter && e.submitter !== addBtn) return;
    e.preventDefault(); if (!current || !current.available) return;
    addBtn.disabled = true; var label = addBtn.textContent; addBtn.textContent = 'Adding…'; if (msg) msg.hidden = true;
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: current.id, quantity: Math.max(1, parseInt(qty.value, 10) || 1) }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        ['cart:update', 'cart:refresh'].forEach(function (t) { document.dispatchEvent(new CustomEvent(t, { bubbles: true })); });
        if (toast) { toast.hidden = false; clearTimeout(tt); tt = setTimeout(function () { toast.hidden = true; }, 5000); }
      })
      .catch(function (err) { if (msg) { msg.textContent = (err && (err.description || err.message)) || 'Sorry, that could not be added. Please try again.'; msg.hidden = false; } })
      .finally(function () { addBtn.disabled = !current.available; addBtn.textContent = label; });
  });

  /* tabs: highlight current section */
  var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-tab]'));
  var tabsBar = root.querySelector('[data-tabs]'), lockUntil = 0;
  function scroller() { var pw = document.querySelector('.page-wrapper'); if (pw && pw.scrollHeight > pw.clientHeight + 2 && /(auto|scroll)/.test(getComputedStyle(pw).overflowY)) return pw; return null; }
  function headerH() {
    var hg = document.getElementById('header-group'); if (!hg) return 0;
    var h = hg.getBoundingClientRect().height, top = hg.querySelector('.rshd-top');
    /* the top bar collapses once the page is scrolled, so aim for the collapsed height */
    if (top && !hg.querySelector('.rshd.is-stuck')) h -= top.getBoundingClientRect().height;
    return h;
  }
  /* highlight a tab and scroll only the tabs strip sideways (never the page) */
  function setOn(t) {
    tabs.forEach(function (x) { x.classList.toggle('is-on', x === t); });
    if (!t || !tabsBar) return;
    var strip = t.parentElement; while (strip && strip !== tabsBar.parentElement && strip.scrollWidth <= strip.clientWidth + 1) strip = strip.parentElement;
    if (!strip || strip === tabsBar.parentElement) return;
    var sr = strip.getBoundingClientRect(), tr = t.getBoundingClientRect();
    if (tr.left < sr.left) strip.scrollLeft -= (sr.left - tr.left) + 16; else if (tr.right > sr.right) strip.scrollLeft += (tr.right - sr.right) + 16;
  }
  function jump(id, t, smooth) {
    var sec = document.getElementById(id); if (!sec) return;
    var sc = scroller(), offset = headerH() + (tabsBar ? tabsBar.getBoundingClientRect().height : 0) + 12;
    var cur = sc ? sc.scrollTop : window.pageYOffset, y = cur + sec.getBoundingClientRect().top - offset;
    lockUntil = Date.now() + 1500; setOn(t);
    (sc || window).scrollTo({ top: Math.max(0, y), behavior: smooth ? 'smooth' : 'auto' });
    /* correct once the scroll has settled: the header shrinks while scrolling, so measure the real (sticky) tabs bar bottom */
    function fix() {
      var off2 = tabsBar ? tabsBar.getBoundingClientRect().bottom + 12 : headerH() + 12, d = sec.getBoundingClientRect().top - off2;
      setOn(t);
      if (Math.abs(d) > 4) { var c2 = sc ? sc.scrollTop : window.pageYOffset; (sc || window).scrollTo({ top: Math.max(0, c2 + d), behavior: 'instant' }); }
    }
    setTimeout(fix, smooth ? 700 : 60); setTimeout(fix, smooth ? 1100 : 400);
    try { history.replaceState(null, '', '#' + id); } catch (e) {}
  }
  tabs.forEach(function (t) { t.addEventListener('click', function (e) { var id = (t.getAttribute('href') || '').slice(1); if (!document.getElementById(id)) return; e.preventDefault(); jump(id, t, true); }); });
  if (location.hash && /^#rspp-/.test(location.hash)) { var ht = tabs.filter(function (t) { return t.getAttribute('href') === location.hash; })[0]; setTimeout(function () { jump(location.hash.slice(1), ht, false); }, 300); }
  if ('IntersectionObserver' in window && tabs.length) {
    var map = {}; tabs.forEach(function (t) { map[t.getAttribute('href').slice(1)] = t; });
    var io = new IntersectionObserver(function (es) {
      if (Date.now() < lockUntil) return;
      es.forEach(function (en) { if (en.isIntersecting) { var t = map[en.target.id]; if (t) setOn(t); } });
    }, { rootMargin: '-35% 0px -60% 0px' });
    Object.keys(map).forEach(function (id) { var s = document.getElementById(id); if (s) io.observe(s); });
  }

  /* checker */
  var mode = root.getAttribute('data-mode'), chk = root.querySelector('[data-chk]');
  var hIn = root.querySelector('[data-chk-h]'), res = root.querySelector('[data-chk-res]');
  function rampLen() {
    var opts = current ? current.options : [], m;
    for (var i = 0; i < opts.length; i++) { m = String(opts[i]).match(/(\d[\d,]{2,5})\s*mm\s*(L\b|Long)/i); if (m) return +m[1].replace(/,/g, ''); }
    if (data.lenOpt >= 0 && opts[data.lenOpt]) { m = String(opts[data.lenOpt]).match(/(\d[\d,]{2,5})\s*mm/); if (m) return +m[1].replace(/,/g, ''); }
    return data.len || 0;
  }
  function draw(h, L) {
    var ramp = root.querySelector('[data-chk-ramp]'), bed = root.querySelector('[data-chk-bed]'), ang = root.querySelector('[data-chk-ang]');
    if (!ramp || !h || !L || h >= L) return;
    var a = Math.asin(h / L), len = 230, x2 = 276, y2 = 130 - len * Math.sin(a), x1 = x2 - len * Math.cos(a);
    y2 = Math.max(12, y2);
    ramp.setAttribute('x1', x1.toFixed(1)); ramp.setAttribute('y1', 130); ramp.setAttribute('x2', x2); ramp.setAttribute('y2', y2.toFixed(1));
    bed.setAttribute('y', y2.toFixed(1)); bed.setAttribute('height', (130 - y2).toFixed(1));
    ang.textContent = (a * 180 / Math.PI).toFixed(1) + '°';
  }
  function geo(h, L) { var a = Math.asin(h / L), run = Math.sqrt(L * L - h * h); return { deg: (a * 180 / Math.PI).toFixed(1), pct: Math.round(h / run * 100), ratio: (run / h).toFixed(1) }; }
  function runCheck(quiet) {
    if (!chk || !hIn) return;
    var h = parseFloat(hIn.value); if (!h || h <= 0) { if (!quiet) res.innerHTML = '<div class="rspp-chk__st is-bad">Enter a height in millimetres.</div>'; return; }
    var L = rampLen(), html = '';
    if (mode === 'access') {
      var n15 = Math.ceil(h * 15), n12 = Math.ceil(h * 12), lens = [];
      var f = fields.filter(function (x) { return +x.getAttribute('data-opt') === data.lenOpt; })[0];
      if (f) f.querySelectorAll('[data-val]').forEach(function (b) { var m = b.getAttribute('data-val').match(/(\d[\d,]{2,5})\s*mm/); if (m) lens.push({ mm: +m[1].replace(/,/g, ''), b: b }); });
      lens.sort(function (x, y) { return x.mm - y.mm; });
      var pick = lens.filter(function (x) { return x.mm >= n15; })[0];
      html += '<div class="rspp-chk__st ' + (pick ? 'is-ok' : 'is-bad') + '"><span><b>About ' + n15.toLocaleString('en-GB') + 'mm of ramp at 1:15</b>(or ' + n12.toLocaleString('en-GB') + 'mm at a steeper 1:12) for a ' + h + 'mm rise.</span></div>';
      if (pick) html += '<p class="rspp-chk__meta">Nearest length: <button type="button" data-pick="' + esc(pick.b.getAttribute('data-val')) + '">select ' + esc(pick.b.getAttribute('data-val')) + '</button></p>';
      else if (lens.length) html += '<p class="rspp-chk__meta">That is longer than the lengths listed here — add platforms or ask us for a layout. <button type="button" data-quote-open>Get a quote</button></p>';
      if (L && h < L) { var g = geo(h, L); html += '<p class="rspp-chk__meta">Selected length (' + L.toLocaleString('en-GB') + 'mm): ' + g.deg + '° · about 1:' + g.ratio + '</p>'; draw(h, L); }
    } else {
      if (!L) { res.innerHTML = '<div class="rspp-chk__st">Choose a size first.</div>'; return; }
      if (h >= L) { res.innerHTML = '<div class="rspp-chk__st is-bad"><span><b>Too high for a ' + L + 'mm ramp.</b>Look at a longer ramp below.</span></div>'; return; }
      var g2 = geo(h, L), min = data.min, max = data.max;
      if (mode === 'load' && min && max) {
        if (h < min) html = '<div class="rspp-chk__st is-bad"><span><b>Below this ramp\'s ' + min + 'mm minimum load height.</b>The ramp won\'t sit flat on the ground — a shorter ramp or a custom cut will suit better.</span></div>';
        else if (h > max) html = '<div class="rspp-chk__st is-bad"><span><b>Above this ramp\'s ' + max + 'mm maximum load height.</b>It would be too steep — choose a longer ramp. <a href="#rspp-compare">Compare sizes</a></span></div>';
        else html = '<div class="rspp-chk__st is-ok"><span><b>Yes — ' + h + 'mm is within this ramp\'s ' + min + '–' + max + 'mm range.</b>Check your machine\'s weight against the capacity in the specifications.</span></div>';
      }
      html += '<p class="rspp-chk__meta">With a ' + L.toLocaleString('en-GB') + 'mm ramp: ' + g2.deg + '° angle · ' + g2.pct + '% gradient</p>';
      draw(h, L);
    }
    res.innerHTML = html;
    res.querySelectorAll('[data-pick]').forEach(function (b) { b.addEventListener('click', function () { var v = b.getAttribute('data-pick'); var s = root.querySelector('[data-opt="' + data.lenOpt + '"] [data-optsel]'); if (s) { s.value = v; s.dispatchEvent(new Event('change')); s.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; } var t = root.querySelector('[data-opt="' + data.lenOpt + '"] [data-val="' + CSS.escape(v) + '"]'); if (t) { t.click(); t.scrollIntoView({ behavior: 'smooth', block: 'center' }); } }); });
    res.querySelectorAll('[data-quote-open]').forEach(function (b) { b.addEventListener('click', openQuote); });
  }
  if (chk) {
    root.querySelector('[data-chk-go]').addEventListener('click', function () { runCheck(false); });
    hIn.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); runCheck(false); } });
    var link = root.querySelector('[data-chk-link]');
    if (link) link.addEventListener('click', function () { setTimeout(function () { hIn.focus({ preventScroll: true }); }, 450); });
    if (data.min && data.max) draw(Math.round((data.min + data.max) / 2), rampLen());
  }

  /* quote dialog */
  var dlg = root.querySelector('[data-quote]');
  function openQuote() {
    if (!dlg) return;
    var body = dlg.querySelector('[data-quote-body]');
    if (body && !body.value) {
      var lines = [];
      if (current && current.options && !(current.options.length === 1 && current.options[0] === 'Default Title')) lines.push('Option: ' + current.options.join(' / '));
      lines.push('Quantity: ' + (qty ? qty.value : 1));
      if (hIn && hIn.value) lines.push((mode === 'access' ? 'Height to rise: ' : 'Load height: ') + hIn.value + 'mm');
      lines.push(''); body.value = lines.join('\n');
    }
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
  }
  root.querySelectorAll('[data-quote-open]').forEach(function (b) { b.addEventListener('click', openQuote); });
  if (dlg) {
    dlg.querySelectorAll('[data-quote-close]').forEach(function (b) { b.addEventListener('click', function () { dlg.close(); }); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    if (dlg.querySelector('[data-quote-ok]') || dlg.querySelector('.rspp-qf__err')) openQuote();
  }
})();
